module.exports = __webpack_public_path__ + "4681b81cf5e7775c48af069617eae0.svg";